import styled from 'styled-components';

const Container = styled.div`
  inset: 0;
  overflow: hidden;
  pointer-events: none;
  position: absolute;
  z-index: -1;
`;

const Grid = styled.div`
  --grid: color-mix(in oklab, var(--ink) 8%, transparent);

  background-image:
    linear-gradient(to right, var(--grid) 1px, transparent 1px),
    linear-gradient(to bottom, var(--grid) 1px, transparent 1px);
  background-size: 48px 48px;
  inset: 0;
  -webkit-mask-image: radial-gradient(ellipse 70% 60% at 50% 0%, black 40%, transparent 100%);
  mask-image: radial-gradient(ellipse 70% 60% at 50% 0%, black 40%, transparent 100%);
  position: absolute;

  .dark & {
    --grid: color-mix(in oklab, white 6%, transparent);
  }
`;

const Glow = styled.div`
  border-radius: 9999px;
  filter: blur(64px);
  position: absolute;
`;

const IndigoGlow = styled(Glow)`
  background-color: color-mix(in oklab, var(--brand-indigo) 25%, transparent);
  height: 512px;
  left: 25%;
  top: -160px;
  width: 512px;

  .dark & {
    background-color: color-mix(in oklab, var(--brand-indigo) 20%, transparent);
  }
`;

const PinkGlow = styled(Glow)`
  background-color: color-mix(in oklab, var(--brand-pink) 20%, transparent);
  height: 448px;
  right: 0;
  top: 80px;
  width: 448px;

  .dark & {
    background-color: color-mix(in oklab, var(--brand-pink) 15%, transparent);
  }
`;

/**
 * Subtle 48px grid with two brand-coloured blurred glows, for behind hero
 * sections. Decorative and static. The parent must be
 * `position: relative; isolation: isolate; overflow: hidden`.
 *
 *   <Hero>            // position: relative; isolation: isolate; overflow: hidden
 *     <HeroBackground />
 *     …
 *   </Hero>
 */
const HeroBackground = ({ className }) => (
  <Container aria-hidden="true" className={className}>
    <Grid />
    <IndigoGlow />
    <PinkGlow />
  </Container>
);

export default HeroBackground;
